import { Link } from "react-router-dom";
import Logo from "@/components/common/Logo";

const ConsumerFooter = () => {
  return (
    <footer className="border-t border-gray-800 py-8 px-4">
      <div className="container mx-auto text-center text-gray-400">
        <Logo className="text-[#ffd700] mb-4" />
        <p className="mb-4">&copy; 2026 GoDyspo. All rights reserved.</p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 sm:gap-6">
          <a 
            href="#faq" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            FAQ
          </a>
          <Link 
            to="/contact" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Contact Us
          </Link>
          <Link 
            to="/privacy-policy" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Privacy Policy
          </Link>
          <Link 
            to="/terms-and-conditions" 
            className="text-gray-400 hover:text-[#ffd700] transition-colors text-sm"
          >
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default ConsumerFooter;
